module.exports = __webpack_public_path__ + "img/add_to_cart.d2e6868e.svg";